import PropTypes from 'prop-types';
import React from 'react';
import {injectIntl} from 'react-intl';
import Badge from '../common/badge/Badge';
import Constants from '../../services/Constants';
import bodyworkIcon from '../../img/icons/src/Bodywork-red.svg'
import fleetbackIcon from '../../img/fleetback-icon.svg';

import './InterventionType.css';

class InterventionType extends React.Component {
  static propTypes = {
    fleetback: PropTypes.bool,
    journey: PropTypes.shape({
      properties: PropTypes.shape({
        reception: PropTypes.shape({
          pickUp: PropTypes.object
        }),
        services: PropTypes.object
      })
    })
  };

  render() {
    if (!this.props.journey || !this.props.journey.properties) {
      return null;
    }

    const {fleetback, intl: {formatMessage}, journey: {properties: {reception = {}, services = {}}}} = this.props;

    const fastLane = reception.dropOff && reception.dropOff.fastLane === true;
    const dropOffDWH = reception.dropOff && reception.dropOff.duringWorkingHours === false;
    const pickupDWH = reception.pickUp && reception.pickUp.duringWorkingHours === false;
    const hasBodyworkService = services.services && services.services.some(service => Constants.BODYWORK_SERVICE.value === service.category);

    return (
      <React.Fragment>
        {fastLane &&
          <Badge content={"FL"}/>
        }
        {dropOffDWH &&
          <Badge content={"\u2192 24/7"}/>
        }
        {pickupDWH &&
          <Badge content={"24/7 \u2192"}/>
        }
        {hasBodyworkService &&
          <Badge className={"badge-bodywork"} content={
            <img style={{height: '1.2rem'}} src={bodyworkIcon} alt={"bodywork icon"} title={formatMessage({id: 'services.category.BODYWORK'})}/>
          }/>
        }
        {fleetback &&
          <Badge content={
            <img style={{height: '1.2rem'}} src={fleetbackIcon} alt={"fleetback icon"}/>
          }/>
        }
      </React.Fragment>

    );
  }
}

export default injectIntl(InterventionType);

